import React, { useState, useRef } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

const MODO_PDF = "pdf";
const MODO_MANUAL = "manual";
const MODO_WHATSAPP = "whatsapp";

export default function Paso2Factura({ leadData, onResultados, onError, setCargando, onReiniciar }) {
  const [modo, setModo] = useState(MODO_PDF);

  // PDF
  const [archivo, setArchivo] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef();

  // Manual
  const [manual, setManual] = useState({
    potencia: "", dias: "", p1_kwh: "", p2_kwh: "", p3_kwh: "", importe: "", cups: ""
  });

  const [error, setError] = useState("");
  const [whatsappEnviado, setWhatsappEnviado] = useState(false);
  const [avisoSinDatos, setAvisoSinDatos] = useState(false);
  const [avisoManual, setAvisoManual] = useState("");
  const [tarifaSospechosa, setTarifaSospechosa] = useState(null);

  const setFile = (f) => {
    if (f && f.name.toLowerCase().endsWith(".pdf")) {
      setArchivo(f); setError(""); setAvisoSinDatos(false); setTarifaSospechosa(null);
    } else {
      setError("Solo se admiten archivos PDF.");
    }
  };

  const rellenarManual = (datos) => {
    setManual({
      potencia: datos.potencia != null ? String(datos.potencia) : "",
      dias:     datos.dias     != null ? String(datos.dias)     : "",
      p1_kwh:   datos.p1_kwh  != null ? String(datos.p1_kwh)   : "",
      p2_kwh:   datos.p2_kwh  != null ? String(datos.p2_kwh)   : "",
      p3_kwh:   datos.p3_kwh  != null ? String(datos.p3_kwh)   : "",
      importe:  datos.importe  != null ? String(datos.importe)  : "",
      cups:     datos.cups     != null ? String(datos.cups)     : "",
    });
    setModo(MODO_MANUAL);
    setArchivo(null);
  };

  const handleManualChange = (e) => {
    setManual({ ...manual, [e.target.name]: e.target.value });
    setError("");
  };

  const handleAnalizar = async () => {
    const tiempoInicio = Date.now();
    setCargando(true);
    setError("");

    try {
      let r, data;

      if (modo === MODO_PDF) {
        if (!archivo) { setCargando(false); setError("Selecciona un archivo PDF."); return; }
        const formData = new FormData();
        formData.append("lead_id", String(leadData.lead_id));
        formData.append("factura", archivo);
        r = await fetch(`${API}/api/comparar`, { method: "POST", body: formData });

      } else {
        // Validar campos obligatorios
        const { potencia, dias, p1_kwh, p2_kwh, p3_kwh, importe } = manual;
        if (!potencia || !dias || !p1_kwh || !importe) {
          setCargando(false);
          setError("Rellena al menos: potencia, días, P1 Punta e importe de la factura.");
          return;
        }
        const formData = new FormData();
        formData.append("lead_id", String(leadData.lead_id));
        formData.append("potencia", potencia);
        formData.append("dias", dias);
        formData.append("p1_kwh", p1_kwh);
        formData.append("p2_kwh", p2_kwh);
        formData.append("p3_kwh", p3_kwh);
        formData.append("importe", manual.importe);
        if (manual.cups) formData.append("cups", manual.cups);
        r = await fetch(`${API}/api/comparar/manual`, { method: "POST", body: formData });
      }

      data = await r.json();

      // Extracción parcial o sin datos
      if (r.status === 206 && data?.parcial) {
        setCargando(false);
        if (data.tarifa_sospechosa) {
          setTarifaSospechosa({ tarifa: data.tarifa_sospechosa, datos: data.datos_extraidos || {}, mensaje: data.mensaje });
        } else if (data.sin_datos) {
          setAvisoSinDatos(true);
        } else {
          rellenarManual(data.datos_extraidos || {});
          setAvisoManual(data.mensaje || "Completa los campos que faltan para continuar.");
        }
        return;
      }

      if (!r.ok) throw new Error(data?.detail || "Error al procesar los datos.");

      const espera = Math.max(0, 3000 - (Date.now() - tiempoInicio));
      setTimeout(() => onResultados(data), espera);

    } catch (e) {
      onError(e.message || "Error al conectar con el servidor.");
    }
  };

  const whatsappUrl = `https://wa.me/34722518123?text=Hola%2C%20quiero%20comparar%20mi%20tarifa%20de%20luz.%20Mi%20nombre%20es%20${encodeURIComponent(leadData?.nombre || "")}`;

  const tabStyle = (t) => ({
    flex: 1, padding: "9px 12px", borderRadius: 7, border: "none", cursor: "pointer",
    fontFamily: "var(--mono)", fontSize: 12, transition: "all .2s",
    background: modo === t ? "var(--accent)" : "none",
    color: modo === t ? "#000" : "var(--text2)",
    fontWeight: modo === t ? 600 : 400,
  });

  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <h2 style={{
          fontFamily: "var(--display)", fontSize: "clamp(22px, 4vw, 34px)",
          fontWeight: 800, letterSpacing: "-0.02em", marginBottom: 10,
        }}>
          Sube tu <span style={{ color: "var(--accent)" }}>factura de luz</span>
        </h2>
        <p style={{ color: "var(--text2)", fontSize: 14 }}>
          Hola <strong style={{ color: "var(--text)" }}>{leadData?.nombre?.split(" ")[0] || ""}!</strong>{" "}
          Elige cómo quieres introducir los datos de tu factura.
        </p>
      </div>

      {/* TABS */}
      <div style={{
        display: "flex", gap: 2, background: "var(--surface)", border: "1px solid var(--border)",
        borderRadius: "var(--radius)", padding: 4, marginBottom: 24,
      }}>
        <button style={tabStyle(MODO_PDF)} onClick={() => { setModo(MODO_PDF); setError(""); setAvisoSinDatos(false); }}>
          📄 Subir PDF
        </button>
        <button style={tabStyle(MODO_MANUAL)} onClick={() => { setModo(MODO_MANUAL); setError(""); }}>
          ✏️ Datos manuales
        </button>
        <button style={tabStyle(MODO_WHATSAPP)} onClick={() => { setModo(MODO_WHATSAPP); setError(""); }}>
          💬 WhatsApp
        </button>
      </div>

      {/* PDF */}
      {modo === MODO_PDF && (
        <div className="card">
          <div className="card-title">Subir factura PDF</div>
          <div
            className={`drop-zone ${dragOver ? "drag-over" : ""}`}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => { e.preventDefault(); setDragOver(false); setFile(e.dataTransfer.files[0]); }}
            onClick={() => inputRef.current.click()}
          >
            <div className="dz-icon">📋</div>
            <div className="dz-title">Arrastra tu factura aquí</div>
            <div className="dz-sub">o haz clic para seleccionar el PDF</div>
            <input ref={inputRef} type="file" accept=".pdf"
              style={{ display: "none" }} onChange={(e) => setFile(e.target.files[0])} />
          </div>
          {archivo && (
            <div className="file-selected">
              <span>📄</span>
              <span className="fs-name">{archivo.name}</span>
              <span className="fs-remove" onClick={(e) => { e.stopPropagation(); setArchivo(null); setAvisoSinDatos(false); setTarifaSospechosa(null); }}>✕</span>
            </div>
          )}
          {error && <ErrorBox msg={error} />}
          {avisoSinDatos && (
            <div style={{
              marginTop: 16, background: "rgba(245,166,35,.07)",
              border: "1px solid rgba(245,166,35,.3)", borderRadius: 10,
              padding: "16px 18px", textAlign: "center",
            }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>📄</div>
              <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.7, marginBottom: 14 }}>
                No hemos podido leer tu factura.<br />
                Siempre puedes introducir los datos manualmente.
              </p>
              <button className="btn btn-primary" onClick={() => {
                setAvisoSinDatos(false);
                setModo(MODO_MANUAL);
              }}>
                ✏️ Introducir datos manualmente
              </button>
            </div>
          )}
          {!avisoSinDatos && (
            <button className="btn btn-primary" onClick={handleAnalizar}
              disabled={!archivo} style={{ marginTop: 20 }}>
              ⚡ Analizar mi factura
            </button>
          )}
        </div>
      )}

      {/* MANUAL */}
      {modo === MODO_MANUAL && (
        <div className="card">
          <div className="card-title">Introduce los datos de tu factura</div>

          <div className="form-grid" style={{ marginBottom: 16 }}>
            <div className="field">
              <label>Potencia contratada (kW) *</label>
              <input type="text" name="potencia" inputMode="decimal" placeholder="ej: 3.3"
                value={manual.potencia} onChange={handleManualChange} />
            </div>
            <div className="field">
              <label>Días facturados *</label>
              <input type="text" name="dias" inputMode="numeric" placeholder="ej: 30"
                value={manual.dias} onChange={handleManualChange} />
            </div>
            <div className="field">
              <label>P1 Punta (kWh) *</label>
              <input type="text" name="p1_kwh" inputMode="decimal" placeholder="ej: 72"
                value={manual.p1_kwh} onChange={handleManualChange} />
            </div>
            <div className="field">
              <label>P2 Llano (kWh) *</label>
              <input type="text" name="p2_kwh" inputMode="decimal" placeholder="ej: 91"
                value={manual.p2_kwh} onChange={handleManualChange} />
            </div>
            <div className="field">
              <label>P3 Valle (kWh) *</label>
              <input type="text" name="p3_kwh" inputMode="decimal" placeholder="ej: 116"
                value={manual.p3_kwh} onChange={handleManualChange} />
            </div>
            <div className="field">
              <label>Importe factura actual (€) *</label>
              <input type="text" name="importe" inputMode="decimal" placeholder="ej: 90.72"
                value={manual.importe} onChange={handleManualChange} />
            </div>
            <div className="field" style={{ gridColumn: "1 / -1" }}>
              <label translate="no">CUPS <span style={{ color: "var(--text3)" }}>(opcional)</span></label>
              <input type="text" name="cups" placeholder="ES0031103192794001QE0F"
                translate="no" value={manual.cups} onChange={handleManualChange} />
            </div>
          </div>

          <div style={{
            background: "rgba(77,159,255,.07)", border: "1px solid rgba(77,159,255,.2)",
            borderRadius: 8, padding: "10px 14px", fontSize: 12, color: "var(--text2)", marginBottom: 16,
          }}>
            * Campos obligatorios. P2 y P3 son opcionales si tu tarifa no los incluye.
          </div>

          {error && <ErrorBox msg={error} />}
          <button className="btn btn-primary" onClick={handleAnalizar} style={{ marginTop: 4 }}>
            ⚡ Comparar tarifas
          </button>
        </div>
      )}

      {/* WHATSAPP */}
      {modo === MODO_WHATSAPP && !whatsappEnviado && (
        <div className="card">
          <div className="card-title">Enviar por WhatsApp</div>
          <p style={{ color: "var(--text2)", fontSize: 14, marginBottom: 20, lineHeight: 1.7 }}>
            Si no tienes la factura a mano o prefieres que te ayudemos personalmente,
            envíanos la factura por WhatsApp y nuestro equipo te hará la comparativa.
          </p>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp"
            onClick={() => setTimeout(() => setWhatsappEnviado(true), 1500)}>
            <span>💬</span> Abrir WhatsApp
          </a>
        </div>
      )}

      {/* WHATSAPP CONFIRMACIÓN */}
      {modo === MODO_WHATSAPP && whatsappEnviado && (
        <div className="card" style={{ textAlign: "center" }}>
          <div style={{ fontSize: 52, marginBottom: 16 }}>🎉</div>
          <div className="card-title" style={{ fontSize: 20, marginBottom: 12 }}>¡Mensaje enviado!</div>
          <p style={{ color: "var(--text2)", fontSize: 14, lineHeight: 1.7, marginBottom: 24, maxWidth: 400, margin: "0 auto 24px" }}>
            Nuestro equipo recibirá tu factura por WhatsApp y te contactará en breve
            con tu comparativa personalizada. No tienes que hacer nada más.
          </p>
          <div style={{
            background: "rgba(0,229,160,.07)", border: "1px solid rgba(0,229,160,.25)",
            borderRadius: 10, padding: "14px 20px", marginBottom: 24,
            fontSize: 13, color: "var(--green)",
          }}>
            ✓ En breve nos pondremos en contacto contigo
          </div>
          <button className="btn btn-secondary" onClick={onReiniciar}>
            ↩ Realizar otra comparativa
          </button>
        </div>
      )}
      {/* TARIFA SOSPECHOSA — pantalla grande con 2 botones */}
      {tarifaSospechosa && (
        <div className="card" style={{ textAlign: "center", padding: "32px 24px" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <h3 style={{
            fontFamily: "var(--display)", fontSize: 20, fontWeight: 800,
            marginBottom: 12, letterSpacing: "-0.02em",
          }}>
            Tarifa no compatible detectada
          </h3>
          <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.8, marginBottom: 28, maxWidth: 460, margin: "0 auto 28px" }}>
            {tarifaSospechosa.mensaje}
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, maxWidth: 340, margin: "0 auto" }}>
            <button className="btn btn-primary" onClick={() => {
              rellenarManual(tarifaSospechosa.datos);
              setTarifaSospechosa(null);
              setAvisoManual("Has indicado que tu factura es 2.0TD. Revisa los datos extraídos y completa los que falten.");
            }}>
              ✅ Mi factura es 2.0TD — continuar
            </button>
            <button className="btn btn-secondary" onClick={() => {
              setTarifaSospechosa(null);
              setArchivo(null);
            }}>
              📄 Probar con otra factura
            </button>
          </div>
        </div>
      )}

      {/* BOTÓN REINICIO SIEMPRE VISIBLE */}
      <div style={{ textAlign: "center", marginTop: 16 }}>
        <button className="btn btn-secondary" onClick={onReiniciar}
          style={{ fontSize: 13, opacity: 0.7 }}>
          ↩ Volver a empezar
        </button>
      </div>
    </div>
  );
}

function ErrorBox({ msg }) {
  return (
    <div style={{
      marginTop: 12, background: "rgba(255,91,91,.08)",
      border: "1px solid rgba(255,91,91,.3)", borderRadius: 8,
      padding: "10px 14px", color: "var(--red)", fontSize: 13,
    }}>⚠ {msg}</div>
  );
}